<template>
    <el-card>
    <template v-slot:header>
        <div class="clearfix">
            <span style="font-weight: bold;">
                <i class="el-icon-s-order" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>
                {{chartTitle}}
            </span>
            <el-button type="primary" icon="el-icon-download" size="small" @click="downloadChart('png')" style="float: right;background-color: #2C3E50;border: 1px solid #2C3E50;">Download PNG</el-button>
            <el-button type="primary" icon="el-icon-download" size="small" @click="downloadChart('svg')" 
            style="float: right;margin-right: 5px;background-color: #2C3E50;border: 1px solid #2C3E50;">Download SVG</el-button>
        </div>
    </template>
    <div>
        <div ref="chart" style="width: 100%; height: 500px;"></div>
    </div>
</el-card>
</template>

<script>
export default {
    name: 'DensityChart',
    props: {
        overlapRegions: Array,
        chartTitle: {
            type: String,
            default: 'Overlap Rate Distribution',
        },
    },
    data() {
        return{
            dataArray: [], // 定义一个数组，用于存储从 overlapRegions 提取的重叠率数据
            chart: null, // 定义一个变量来存储 echarts 实例
        }
    },
    methods: {
        drawChart() {
            const overlapRateArr = this.overlapRegions.map(item => item[2]); // 首先提取 overlapRegions 中所有的重叠率数据
            this.dataArray.push(overlapRateArr); // 将重叠率数据 push 到 dataArray 中
            // 移除无效值，比如 null、undefined、空字符串等
            this.dataArray = this.dataArray.filter(val => val && val.length);
            // 初始化 echarts 实例
            const chart = this.chart || this.$echarts.init(this.$refs.chart);
            // 配置项
            const option = {
                tooltip: {
                trigger: 'axis', // 触发类型设置为坐标轴触发，即在坐标轴上显示数据
                axisPointer: {
                    type: 'shadow', // 坐标轴指示器类型，阴影指示器表示选中范围，直线指示器表示选中点位置
                },
                },
                xAxis: {
                type: 'category',
                data: [
                    '0-0.1',
                    '0.1-0.2',
                    '0.2-0.3',
                    '0.3-0.4',
                    '0.4-0.5',
                    '0.5-0.6',
                    '0.6-0.7',
                    '0.7-0.8',
                    '0.8-0.9',
                    '0.9-1',
                ],
                },
                yAxis: {
                type: 'value',
                name: 'Count',
                },
                series: [
                {
                    data: this.getHistogramData(),
                    type: 'bar',
                    barWidth: 30,
                    itemStyle: {
                        color: '#ECC042',
                    },
                    label: {
                        show: true, // 展示柱子上方的数值
                        position: 'top',
                        color: '#333' // 修改数值文字颜色为黑色
                    }
                },
                ],
            };
            // 使用刚指定的配置项和数据显示图表
            chart.setOption(option);
        },
        // 获取直方图数据
        getHistogramData() {
        const flattenedArray = [].concat(...this.dataArray); // 将二维数组变成一维数组
        const countArr = [];
        for (let i = 0; i <= 1; i += 0.1) {
            let binCount = 0;
            for (let j = 0; j < flattenedArray.length; j++) {
            if (flattenedArray[j] >= i && flattenedArray[j] < i + 0.1) {
                binCount++;
            }
            }
            countArr.push(binCount);
        }
        return countArr;
        },
        // 下载图表
        downloadChart(format) {
            if (!this.chart) {
                this.chart = this.$echarts.init(this.$refs.chart);
            }
            // 获取图表 base64 编码数据
            const options = {
            type: format,
            pixelRatio: 2,
            backgroundColor: '#fff',
            };
            const imageData = this.chart.getDataURL(options);

            // 创建 a 标签并设置属性
            const link = document.createElement('a');
            link.href = imageData;
            link.download = `chart.${format}`;

            // 触发下载
            link.click();
        },
        mounted() {
            this.drawChart();
        },
        // 在组件销毁前清空 echarts 实例和 dataArray 数组
        beforeDestroy() {
            this.chart.dispose();
            this.dataArray = [];
        },
    },
    watch: {
            overlapRegions: {
            handler() {
                this.drawChart();
            },
            deep: true,
            },
        },
};
</script>


// WEBPACK FOOTER //
// src/components/overlap/Overlapfig1.vue